import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarPetaRisikoTenagaKesehatan from "../../components/TopBarPetaRisikoTenagaKesehatan";
import PetaRisiko from "../../components/PetaRisiko";
import "../../CSS/SemuaDataPasienTK.css";

function HalamanDataPetaRisikoTenagaKesehatan() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarPetaRisikoTenagaKesehatan />

        {/* Konten utama */}
        <div className="main-content-pasien">
          <PetaRisiko />
        </div>
      </div>
    </div>
  );
}

export default HalamanDataPetaRisikoTenagaKesehatan;
